<div class="home-section first"
  [ngStyle]="{'background-image': 'url(' + homeSlides[currentSlide]?.imagePath ? (assets_base + homeSlides[currentSlide]?.imagePath) : null +')'}">
  <div class="page-wide">
    <h1 class="section-title">FAIRBRIDGE HOTELS</h1>
    <form [formGroup]="options">
      <div class="booking-form theme-form d-flex">
        <div class="input-block destination">
          <label>DESTINATION</label>
          <ng-select formControlName="webUrl" [items]="properties" placeholder="Where are you going?" bindLabel="name"
            bindValue="webUrl" groupBy="state" [searchFn]="propertySearchFn" [loading]="propertyLoading">
            <ng-template ng-optgroup-tmp let-item="item">
              {{item.state || 'Others'}}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{item.name}} <br />
              <small><strong>{{item.city}}</strong></small>
            </ng-template>
          </ng-select>
        </div>

        <div class="input-block dates">
          <label>DATES</label>
          <input type="text" ngxDaterangepickerMd class="form-control" [(ngModel)]="selectedDateRange"
          [locale]="{format: 'YYYY-MM-DD', displayFormat: 'DD/MM/YYYY'}"
            [ngModelOptions]="{standalone: true}" [autoApply]="true"
            placeholder="Check-in &nbsp; &nbsp; &#8594; &nbsp; &nbsp; Check-out" />
        </div>

        <button (click)="bookNow()">Search</button>
      </div>
    </form>

    <div class="image-gallery-slides" *ngIf="homeSlides?.length">
      <div class="image-gallery-slide d-none d-lg-block">
        <div class="title">{{homeSlides[currentSlide]?.caption}}</div>
        <div class="city">{{homeSlides[currentSlide]?.subCaption}}</div>
        <hr />
        <div class="middle-rates" *ngIf="homeSlides[currentSlide]?.rate && homeSlides[currentSlide]?.rateLabel">
          <div class="small-caption">{{homeSlides[currentSlide]?.rateLabel}}</div>
          <div class="rate">${{homeSlides[currentSlide]?.rate}}</div>
        </div>
        <hr />
        <div *ngIf="homeSlides[currentSlide]?.hyperlink && homeSlides[currentSlide]?.hyperlinkButtonLabel">
          <a [href]="homeSlides[currentSlide]?.hyperlink">
            <button type="button" class="black-btn btn btn-dark">{{homeSlides[currentSlide]?.hyperlinkButtonLabel}}</button>
          </a>
        </div>
      </div>
    </div>
    <div class="slide-controls-bottom">
      <button *ngFor="let slide of homeSlides; let rowIndex = index" class="bottom-control"
        [ngClass]="{'active': rowIndex === currentSlide}" (click)="setSlide(rowIndex)"></button>
    </div>
  </div>
</div>

<div id="brands" class="page-wide">
  <div class="our-brands home-section">
    <h3>Our Brands</h3>


    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs mb-md-5">
      <li *ngFor="let brand of brands" [ngbNavItem]="brand.id">
        <button ngbNavLink class="text-uppercase custom-text">{{brand.title}}</button>
        <ng-template ngbNavContent>
          <div class="d-flex gap-5 mt-5 flex-sm-row flex-column">
            <div class="w-md-40 me-4 text-center">
              <img [src]="brand.logo" width="300"/>
              <div class="mt-5 fs-3 fw-normal  custom-text">{{brand.name}}</div>
            </div>
            <div class="flex-grow-1">
              @if (!propertyLoading) {
                <div class="brand_hotels">
                  <ul class="d-flex flex-wrap mt-0">
                    <li class="mb-1" *ngFor="let property of propertiesGroup[hotelCategories[brand.hotelCategoryIndex]]; let rowIndex = index">
                      <a class="text-decoration-none" [routerLink]="['hotel', property?.slug]">{{property?.city}}</a>
                    </li>
                  </ul>
                </div>
              } @else {
                <p class="placeholder-glow">
                  <span class="placeholder col-7"></span>
                  <span class="placeholder col-4"></span>
                  <span class="placeholder col-4"></span>
                  <span class="placeholder col-6"></span>
                  <span class="placeholder col-8"></span>
                </p>
              }
              
            </div>
          </div>
        </ng-template>
      </li>
    </ul>
    
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>


<div class="featured-hotels home-section">
  <div class="page-wide">
    <h3>Our Featured Hotel</h3>

    <div class="featured-hotels-slider">
      <div class="slide" *ngFor="let featuredProperty of brand?.featuredProperties; let rowIndex = index">
        <div *ngIf="rowIndex === 0">
          <a [routerLink]="['hotel', featuredProperty?.slug]">
            <img *ngIf="featuredProperty?.teaserImage" [src]="featuredProperty?.teaserImage.amazonS3Url" />
            <div class="title">{{featuredProperty?.name}} </div>
          </a>
            <span class="caption">{{featuredProperty?.city}}</span>
            <div class="description">
              {{featuredProperty?.description}}
            </div>
            <a [href]="featuredProperty?.webUrl">
              <button type="button" class="btn btn-primary">Book Now</button>
            </a>

        </div>
      </div>
    </div>
  </div>
</div>

<div class="page">
  <div class="fairbridge-promise home-section px-3">
    <div class="title-upperline"></div>
    <div class="title">The FairBridge Promise</div>
    <p>
      The FairBridge story began in Spokane, Washington with a single hotel
      and a single promise to travelers. Today, we share that same promise
      of a clean, affordable, and friendly stay at a growing number of
      FairBridge locations across the country.
    </p>
    <p>
      Our consistent delivery on
      this promise over the years has earned the loyalty and trust of
      growing numbers of families, businesses, and leisure travelers finding
      their path to FairBridge Hotels every day.
    </p>
    <p>
      Whatever the need or
      purpose of your travel, let FairBridge find you just the right room to
      roam, room to rest, room to play, and most importantly room to stay.
    </p>
  </div>
</div>

<div class="fairbridge-map home-section">
  <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="space-between bottom">
    <div class="left" fxFlex="35">
      <div class="title">FAIRBRIDGE HOTELS</div>
      <p>
        Whether it's the east coast, west coast or anywhere in-between, you
        can rely on Fairbridge Hotels to help you find the place that suits your
        wants, needs and most importantly your style.
      </p>
    </div>
    <div class="right" *ngIf="properties" fxFlex="65">
      <google-map [options]="googleMapOptions" [center]="{lat: 38.24, lng: -95.9}" [zoom]="5" width="100%" [height]="700">
        <ng-template ngFor let-property [ngForOf]="properties">
          <map-marker *ngIf="property?.latitude && property?.longitude" #marker="mapMarker"
            [position]="{lat: property?.latitude, lng: property?.longitude}" [options]="markerOptions"
            (mapClick)="openInfoWindow(marker, property)"></map-marker>
        </ng-template>
        <map-info-window>
  
          <div class="map-window" fxLayout="row" fxLayoutGap="16px">
            <div class="image" *ngIf="mapInfoWindowProperty?.propertyImages">
              <img [src]="getFeaturedImage()" width="200" />
            </div>
            <div class="window-text">
              <h4>{{mapInfoWindowProperty?.city}}, {{mapInfoWindowProperty?.state}}</h4>
              <div class="address">
                {{mapInfoWindowProperty?.street}}, {{mapInfoWindowProperty?.city}}, <br />
                {{mapInfoWindowProperty?.state}} {{mapInfoWindowProperty?.postalCode}}
              </div>
              <div class="phone" *ngIf="mapInfoWindowProperty?.phoneNumber">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
                  </svg>
                  <ng-template [ngIf]="mapInfoWindowProperty?.phoneAreacode">({{mapInfoWindowProperty?.phoneAreacode}})
                  </ng-template>
                  {{mapInfoWindowProperty?.phoneNumber}}
                </span>
              </div>
              <a [href]="mapInfoWindowProperty?.webUrl">
                <button type="button" class="btn btn-primary">Book Now</button>
              </a>
            </div>
          </div>
  
        </map-info-window>
      </google-map>
    </div>
  </div>
</div>

<div class="page">
  <app-contact-form></app-contact-form>
</div>